<!-- 查询公众号用户接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "appId": "wx4965abff0ba79af7",
                "phone": "18054103169",
                "pageNum": 1,
                "pageSize": 10,
            },
            responseCode: {
                "data": {
                    "currCount": 1,
                    "recordInList": [
                        {
                            "createTime": 1514962402000,
                            "headPic": "http://thirdwx.qlogo.cn/mmopen/9Jz8j98EE77dybprtoCAiaic0ia3WOALic3FmbuGwQ9fP9BAVYUEOwEpMGrIhdMsibffh1UXOBicw0hVsyyegtUnlEvPhsHeiaynDMw/132",
                            "id": 537,
                            "isBindUser": 1,
                            "nickName": "鲸",
                            "openId": "oDDLWvlgTcqJ9fyBd1r5NecDBmw8",
                            "status": 1,
                            "subscribe": 1,
                            "thirdWeixinAccountIdTag": 2,
                            "unionId": "oKRtNwMlrm9xOzaRKPS0ZeH4Hh-4",
                            "updateTime": 1516775826000,
                            "usedCount": 26,
                            "userId": 3468,
                            "weixinAccountId": 2
                        }
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,查询公众号用户信息",
                t_url: this.commonUrls.test+"getAppIdUsers",
                p_url: this.commonUrls.prod+"getAppIdUsers",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'appId', info2: '是', info3: 'String', info4: '微信appId' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '注册用户手机号码。' },
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '智慧停车用户ID。' },
                        { info1: 'openId', info2: '否', info3: 'Long', info4: '智慧停车微信openid。' },
                        { info1: 'subscribe', info2: '否', info3: 'Integer', info4: '是否关注公众号, 0未关注 1已关注' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '公众号用户状态，0冻结中 1有效 2已注销,注销后,不显示之前的业务数据' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'userList', info2: '是', info3: 'String', info4: '用户信息列表' },
                        ]
                },{
                    titleName: 'userList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userId', info2: '是', info3: 'Long', info4: '用户ID,USER.ID' },
                        { info1: 'openId', info2: '是', info3: 'String', info4: '微信用户识别号' },
                        { info1: 'headPic', info2: '是', info3: 'String', info4: '微信头像' },
                        { info1: 'nickName', info2: '否', info3: 'String', info4: '微信呢称' },
                        { info1: 'subscribe', info2: '是', info3: 'Integer', info4: '是否关注公众号,0 NO 未关注,1 YES 已关注' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '0:FREEZE(冻结中)，1：VALID(有效),2:DESTORY(已注销,注销后,不显示之前的业务数据)' },
                        { info1: 'createDate', info2: '是', info3: 'String', info4: '创建时间，yyyyMMddHHmmss' },
                        { info1: 'updateDate', info2: '是', info3: 'String', info4: '更新时间，yyyyMMddHHmmss' },
                        { info1: 'usedCount', info2: '是', info3: 'Long', info4: '使用次数' },
                        { info1: 'unionId', info2: '是', info3: 'String', info4: '微信体系唯一ID' },
                        { info1: 'isBindUser', info2: '是', info3: 'Integer', info4: '是否绑定智慧停车手机用户0否1是' },
                        { info1: 'weixinAccountId', info2: '是', info3: 'Long', info4: '关联公众号账户ID（运营使用）' },
                        { info1: 'thirdWeixinAccountIdTag', info2: '是', info3: 'Long', info4: '第三方公众号标签(换装使用)' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getAppIdUsers.vue